import React from "react";
import AccreditedInvestorsTable from "./investors/InvestorsList";
import "../../components/common/css/datatable.scss";
import "../../components/common/css/index.scss";

const AccreditedInvestors = () => {
  
  return (
    <div className="list">
      <div className="listContainer">
        <AccreditedInvestorsTable/>
      </div>
    </div>
  );
};

export default AccreditedInvestors;
